import React, { useEffect, useState, useRef } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
import baseURL from "../../../../Url/NodeBaseURL";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";

const PaymentDetails = ({
  saveLoading,
  paymentDetails,
  setPaymentDetails,
  advanceEntries,
  setAdvanceEntries,
  newAdvanceEntries,
  setNewAdvanceEntries,
  newAdvance,
  setNewAdvance,
  handleSave,
  formData,
  handleBack,
  orderDetails,
  totalPrice,
  schemeSalesData,
  oldSalesData,
  taxableAmount,
  totalAmount,
  discountAmt,
  taxAmount,
  oldItemsAmount,
  schemeAmount,
  salesAmountToPass,
  netPayableAmount,
  netAmount,
  discount,
  handleDiscountChange,
  advanceAmount,
  setAdvanceAmount,
  savedNetPayableAmount,
  setSavedNetPayableAmount,
  setIsManualNetPayableSet,
  festivalShowModal,
  handleFestivalShowModal,
  handleFestivalCloseModal,
  appliedOffers,
  setAppliedOffers,
  festivalDiscountAmt,
  manualNetAmount,
  setManualNetAmount,
  handleManualNetAmountChange,
  isManualNetMode,
  setIsManualNetMode,
  handleManualNetPayAmountChange,
  manualNetPayAmount,
  handleManualNetPayableChange,
  handleApply,
  isAnyOfferApplied,
  applyDiscountAmountToOrderDetails,
  selectedRows,
  setNetPayableEditable,
}) => {
  const location = useLocation();
  const [saveLoader, setSaveLoader] = useState(false);
  const [allReservedNeedsSave, setAllReservedNeedsSave] = useState(false);
  const [manualNetPayAmountPayment, setManualNetPayAmountPayment] = useState(0);
  const [editedManualNetPayAmountPayment, setEditedManualNetPayAmountPayment] =
    useState(0);
  const [isSaveNetPayableAmount, setIsSaveNetPayableAmount] = useState(false);
  const [isEditedNetPayableAmount, setIsEditedNetPayableAmount] =
    useState(false);
  const [showGenerateSale, setShowGenerateSale] = useState(false);
  const [isGenerateDisabled, setIsGenerateDisabled] = useState(false);
  const [isAssigned, setIsAssigned] = useState(false);
  const [isOrderCreatedToday, setIsOrderCreatedToday] = useState(false);
  const [isOrder, setIsOrder] = useState(false);
  

  const handleGenerateSales = (e) => {
    e.preventDefault(); // stop form submission
    navigate("/sales", {
      state: {
        from: "orders",
        orderDetails: orderDetails,
      },
    });
  };
  function isCurrentDate(dateString) {
    const today = new Date();
    const date = new Date(dateString);

    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }
  const [isTodayDate, setIsTodayDate] = useState(false);

  useEffect(() => {
    async function isToday() {
      try {
        const response = await axios.get(
          `${baseURL}/get-order-details/${formData.order_number}`
        );

        const uniqueData = response.data?.uniqueData;
        const apiDate = uniqueData.date;

        if (!apiDate) {
          console.warn("Date not found in API response.");
          setIsTodayDate(false);
          return;
        }

        const result = isCurrentDate(apiDate);
        setIsTodayDate(result);
      } catch (error) {
        console.error("Error fetching repair details:", error);
        setIsTodayDate(true);
      }
    }

    if (formData.order_number) {
      isToday();
    }
  }, [formData.order_number]);
  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/get-order-details/${formData.order_number}`
        );
        const repeatedData = (response.data.repeatedData || []).filter(
          (item) => item.invoice_number === null
        );
        setIsOrder(true);

        const hasAtLeastOneSelected = repeatedData.some(
          (item) => item.submission_status === "selected"
        );

        const allOthersValid = repeatedData.every(
          (item) =>
            item.submission_status === "selected" ||
            (item.submission_status === null && item.vendor_id === null)
        );
        const allAssigned =
          repeatedData.length > 0 &&
          repeatedData.every((item) => item.vendor_id !== null);
        if (
          repeatedData.length > 0 &&
          repeatedData.every((item) => item.is_sales_generated === 1)
        ) {
          setIsGenerateDisabled(true);
        } else {
          setIsGenerateDisabled(false);
        }
        setShowGenerateSale(hasAtLeastOneSelected && allOthersValid);
        setIsAssigned(allAssigned);

        const orderDateUTC = new Date(response.data.uniqueData?.date);
        const orderDateIST = new Date(
          orderDateUTC.getTime() + 5.5 * 60 * 60 * 1000
        );

        const todayIST = new Date();
        const todayOffset = todayIST.getTime() + 5.5 * 60 * 60 * 1000;
        const todayInIST = new Date(todayOffset);

        const isSameDay =
          orderDateIST.getDate() === todayInIST.getDate() &&
          orderDateIST.getMonth() === todayInIST.getMonth() &&
          orderDateIST.getFullYear() === todayInIST.getFullYear();

        setIsOrderCreatedToday(isSameDay && !allAssigned);
      } catch (error) {
        console.error("Error fetching order details:", error);
      }
    };

    fetchOrderDetails();
  }, [formData.order_number]);
  useEffect(() => {
    if (orderDetails?.length > 0) {
      const allReserved = orderDetails.every(
        (item) => item.reservation_status === "Reserved"
      );

      if (allReserved) {
        setAllReservedNeedsSave(true);
        setShowGenerateSale(true); // override
      } else {
        setAllReservedNeedsSave(false);
      }
    }
  }, [orderDetails]);

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const buttonStyle = {
    backgroundColor: "#a36e29",
    border: "1px solid #a36e29",
    color: "white",
    fontSize: "14px",
    padding: "4px 8px",
    marginTop: "3px",
    cursor: "pointer",
    borderRadius: "4px",
  };
  const isPaymentEditable = (paymentDate) => {
    const paymentDateTime = new Date(paymentDate);
    const currentDateTime = new Date();
    const diffTime = Math.abs(currentDateTime - paymentDateTime);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays <= 1; // Returns true if payment is 1 day or less old
  };

  useEffect(() => {
    const amt = orderDetails[0]?.advance_amt;
    if (amt && typeof amt === "string") {
      try {
        const parsed = JSON.parse(amt);
        if (Array.isArray(parsed)) {
          setAdvanceEntries(
            parsed.map((entry) => ({
              ...entry,
              paymentMethod: entry.paymentMethod || "-",
            }))
          );
        } else {
          setAdvanceEntries([]);
        }
      } catch {
        setAdvanceEntries([]);
      }
    } else {
      setAdvanceEntries([]);
    }
  }, [orderDetails, setAdvanceEntries]);

  const paymentMethods = [
    { value: "cash", label: "Cash" },
    { value: "online", label: "Online" },
    { value: "bank_transfer", label: "Bank Transfer" },
    { value: "cheque", label: "Cheque" },
    { value: "card", label: "Card" },
  ];

  const navigate = useNavigate();

  useEffect(() => {
    const amt = orderDetails[0]?.advance_amt;
    if (amt && typeof amt === "string") {
      try {
        const parsed = JSON.parse(amt);
        if (Array.isArray(parsed)) {
          setAdvanceAmount(
            parsed.map((entry) => ({
              ...entry,
              paymentMethod: entry.paymentMethod || "-",
            }))
          );
        }
      } catch {
        setAdvanceAmount([]);
      }
    } else {
      setAdvanceAmount([]);
    }
  }, []);

  const maxAdvanceAmount = netAmount;

  // useEffect(() => {
  //   setDiscountAmountInput(discountAmt);
  // }, [discountAmt]);

  const handleAddAdvance = () => {
    if (!newAdvance.amount || !newAdvance.date || !newAdvance.paymentMethod) {
      alert("Please enter amount, date and select payment method.");
      return;
    }
    const totalAdvance = [...advanceEntries, ...newAdvanceEntries].reduce(
      (sum, entry) => sum + Number(entry.amount || 0),
      0
    );
    const newTotal = totalAdvance + Number(newAdvance.amount);
    if (newTotal > maxAdvanceAmount) {
      alert(
        `Total advance amount should not exceed ₹${maxAdvanceAmount.toFixed(
          2
        )}. Remaining: ₹${(maxAdvanceAmount - totalAdvance).toFixed(2)}`
      );
      return;
    }
    const updatedNewAdvanceEntries = [...newAdvanceEntries, { ...newAdvance }];

    setNewAdvanceEntries(updatedNewAdvanceEntries);

    setNewAdvance({ amount: "", date: getTodayDate(), paymentMethod: "" });
  };

  const handleRemoveAdvance = (idx) => {
    // Check if it's a preloaded entry or new entry
    const entry =
      idx < advanceEntries.length
        ? advanceEntries[idx]
        : newAdvanceEntries[idx - advanceEntries.length];

    if (!isPaymentEditable(entry.date)) {
      alert("This payment cannot be edited as it is more than 1 day old.");
      return;
    }

    if (idx < advanceEntries.length) {
      // Remove from advanceEntries
      const updatedEntries = advanceEntries.filter((_, i) => i !== idx);
      setAdvanceEntries(updatedEntries);
    } else {
      // Remove from newAdvanceEntries
      const updatedNewEntries = newAdvanceEntries.filter(
        (_, i) => i !== idx - advanceEntries.length
      );
      setNewAdvanceEntries(updatedNewEntries);
    }
  };

  useEffect(() => {}, [advanceEntries]);

  // Update parent's advanceAmount state when advance entries change
  useEffect(() => {
    const totalAdvanceAmount = [...advanceEntries, ...newAdvanceEntries].reduce(
      (sum, entry) => sum + Number(entry.amount || 0),
      0
    );
    setAdvanceAmount(totalAdvanceAmount);

    // If net payable amount is in saved mode, update the saved amount to reflect advance changes
    if (isSaveNetPayableAmount) {
      // Calculate the new net payable amount based on current deductions
      const totalDeductions =
        oldItemsAmount + schemeAmount + salesAmountToPass + totalAdvanceAmount;
      const newNetPayableAmount = Math.round(netAmount - totalDeductions);

      // Update the saved net payable amount
      setSavedNetPayableAmount(newNetPayableAmount);
      setEditedManualNetPayAmountPayment(newNetPayableAmount);
      setManualNetPayAmountPayment(newNetPayableAmount);
    }
  }, [
    advanceEntries,
    newAdvanceEntries,
    setAdvanceAmount,
    isSaveNetPayableAmount,
    oldItemsAmount,
    schemeAmount,
    salesAmountToPass,
    netAmount,
    setSavedNetPayableAmount,
  ]);
  useEffect(() => {
    if (setNetPayableEditable) {
      setNetPayableEditable.current = () => {
        // Exit saved manual-net mode and allow recalculation on parent-triggered changes
        setIsEditedNetPayableAmount(false);
        setIsSaveNetPayableAmount(false);
        setIsManualNetPayableSet(false);
        // Clear any saved amount so it recalculates freshly from SalesForm
        setSavedNetPayableAmount(0);
      };
    }
  }, [
    setNetPayableEditable,
    setIsManualNetPayableSet,
    setSavedNetPayableAmount,
  ]);
  //const [savedNetPayableAmount, setSavedNetPayableAmount] = useState(0);

  // Log the received savedNetPayableAmount

  const [originalNetPayableAmount, setOriginalNetPayableAmount] = useState(0);
  const [originalNetAmount, setOriginalNetAmount] = useState(0);
  const netPayableInputRef = useRef(null);

  useEffect(() => {
    // Auto-enable editing when sales return checkboxes are selected OR URD purchase changes
    const hasSelectedRows = selectedRows && selectedRows.length > 0;
    const hasOldItems = oldItemsAmount > 0;

    if (hasSelectedRows || hasOldItems) {
      // Only make it editable if the Net Payable Amount hasn't been manually saved
      if (!isSaveNetPayableAmount) {
        setIsEditedNetPayableAmount(false);

        setIsSaveNetPayableAmount(false);
        setIsManualNetPayableSet(false);
      }
      // Keep it non-editable since it's been manually saved
    } else {
      setIsEditedNetPayableAmount(true);
    }
  }, [selectedRows, oldItemsAmount, isSaveNetPayableAmount]);
  useEffect(() => {
    // pull the latest data
    const fetchOrder = async () => {
      try {
        if (location.state?.from === "orders") return;
        // Only update if the values are not empty strings or minus signs
        if (
          typeof netPayableAmount === "number" ||
          (typeof netPayableAmount === "string" &&
            netPayableAmount !== "" &&
            netPayableAmount !== "-")
        ) {
          setManualNetPayAmountPayment(netPayableAmount);
          setEditedManualNetPayAmountPayment(netPayableAmount);
        }
        if (orderDetails[0]?.order_number) {
          const response = await axios.get(
            `${baseURL}/get-order-details/${orderDetails[0].order_number}`
          );

          if (response.data) {
            // Only update if we don't have a valid calculated netPayableAmount
            // or if the API value is significantly different (indicating it might be outdated)
            const apiBalance = response.data.repeatedData[0].bal_amt;
            const calculatedValue = netPayableAmount;

            // If we have a valid calculated value and it's different from API, use calculated
            if (
              calculatedValue &&
              calculatedValue > 0 &&
              Math.abs(calculatedValue - apiBalance) > 1000
            ) {
            } else {
              setManualNetPayAmountPayment(apiBalance);
              setEditedManualNetPayAmountPayment(apiBalance);
            }
          }
        }
      } catch (error) {
        // Error fetching order details
      }
    };

    fetchOrder();
  }, [orderDetails]);

  useEffect(() => {
    // Only update if the values are not empty strings or minus signs
    // AND if the Net Payable Amount hasn't been manually saved
    if (
      (typeof netPayableAmount === "number" ||
        (typeof netPayableAmount === "string" &&
          netPayableAmount !== "" &&
          netPayableAmount !== "-")) &&
      !isSaveNetPayableAmount
    ) {
      setManualNetPayAmountPayment(netPayableAmount);
      setEditedManualNetPayAmountPayment(netPayableAmount);
    }

    // Reset original values when starting fresh (no old items, no sales return)
    const isNewProduct =
      oldItemsAmount === 0 && (!selectedRows || selectedRows.length === 0);

    if (isNewProduct) {
      setOriginalNetPayableAmount(netPayableAmount);
      setOriginalNetAmount(netAmount);
    } else {
      // Store the original net payable amount when first loaded (before any manual changes)
      if (originalNetPayableAmount === 0) {
        setOriginalNetPayableAmount(netPayableAmount);
      }
      // Store the original net amount when first loaded (before any discounts)
      if (originalNetAmount === 0) {
        setOriginalNetAmount(netAmount);
      }
    }
  }, [
    netPayableAmount,
    netAmount,
    originalNetPayableAmount,
    originalNetAmount,
    oldItemsAmount,
    selectedRows,
    isSaveNetPayableAmount,
  ]);

  // Update payment details when net payable amount changes (for any reason)
  useEffect(() => {
    // Only update payment details if net payable amount has changed and it hasn't been manually saved
    if (
      !isSaveNetPayableAmount &&
      typeof netPayableAmount === "number" &&
      netPayableAmount > 0
    ) {
      const updatedNetPayable = Math.round(netPayableAmount);

      // Check if the current online amount is different from the new net payable amount
      const currentOnlineAmount = parseFloat(paymentDetails.online_amt || 0);

      if (currentOnlineAmount !== updatedNetPayable) {
        // Update payment details to set online amount to match net payable
        // and reset other payment methods to 0
        const updatedPaymentDetails = {
          cash_amount: 0,
          card_amt: 0,
          chq_amt: 0,
          online_amt: updatedNetPayable,
        };

        setPaymentDetails(updatedPaymentDetails);
        localStorage.setItem(
          `paymentDetails`,
          JSON.stringify(updatedPaymentDetails)
        );
      }
    }
  }, [netPayableAmount, isSaveNetPayableAmount]);

  // Update net payable amount when sales return items are selected/deselected
  useEffect(() => {
    if (selectedRows && selectedRows.length > 0 && !isSaveNetPayableAmount) {
      // When sales return items are selected, update the net payable amount
      // Only if the Net Payable Amount hasn't been manually saved
      const updatedNetPayable = Math.round(netPayableAmount);
      setManualNetPayAmountPayment(updatedNetPayable);
      setEditedManualNetPayAmountPayment(updatedNetPayable);

      // Only reset payment details if they haven't been manually modified
      const hasManualPayments =
        parseFloat(paymentDetails.cash_amount || 0) > 0 ||
        parseFloat(paymentDetails.card_amt || 0) > 0 ||
        parseFloat(paymentDetails.chq_amt || 0) > 0;

      if (!hasManualPayments) {
        const updatedPaymentDetails = {
          cash_amount: 0,
          card_amt: 0,
          chq_amt: 0,
          online_amt: updatedNetPayable,
        };

        setPaymentDetails(updatedPaymentDetails);
        localStorage.setItem(
          `paymentDetails`,
          JSON.stringify(updatedPaymentDetails)
        );
      }
    }
  }, [selectedRows, netPayableAmount, isSaveNetPayableAmount]);

  // Update net payable amount when URD purchase changes (oldItemsAmount changes)
  useEffect(() => {
    if (oldItemsAmount > 0 && !isSaveNetPayableAmount) {
      // When URD purchase data changes, update the net payable amount
      // Only if the Net Payable Amount hasn't been manually saved
      const updatedNetPayable = Math.round(netPayableAmount);
      setManualNetPayAmountPayment(updatedNetPayable);
      setEditedManualNetPayAmountPayment(updatedNetPayable);

      // Only reset payment details if they haven't been manually modified
      const hasManualPayments =
        parseFloat(paymentDetails.cash_amount || 0) > 0 ||
        parseFloat(paymentDetails.card_amt || 0) > 0 ||
        parseFloat(paymentDetails.chq_amt || 0) > 0;

      if (!hasManualPayments) {
        const updatedPaymentDetails = {
          cash_amount: 0,
          card_amt: 0,
          chq_amt: 0,
          online_amt: updatedNetPayable,
        };

        setPaymentDetails(updatedPaymentDetails);
        localStorage.setItem(
          `paymentDetails`,
          JSON.stringify(updatedPaymentDetails)
        );
      }
    }
  }, [oldItemsAmount, netPayableAmount, isSaveNetPayableAmount]);

  // Update net payable amount when sales return changes (salesAmountToPass changes)
  useEffect(() => {
    if (salesAmountToPass > 0 && !isSaveNetPayableAmount) {
      // When sales return data changes, update the net payable amount
      // Only if the Net Payable Amount hasn't been manually saved
      const updatedNetPayable = Math.round(netPayableAmount);
      setManualNetPayAmountPayment(updatedNetPayable);
      setEditedManualNetPayAmountPayment(updatedNetPayable);

      // Only reset payment details if they haven't been manually modified
      const hasManualPayments =
        parseFloat(paymentDetails.cash_amount || 0) > 0 ||
        parseFloat(paymentDetails.card_amt || 0) > 0 ||
        parseFloat(paymentDetails.chq_amt || 0) > 0;

      if (!hasManualPayments) {
        const updatedPaymentDetails = {
          cash_amount: 0,
          card_amt: 0,
          chq_amt: 0,
          online_amt: updatedNetPayable,
        };

        setPaymentDetails(updatedPaymentDetails);
        localStorage.setItem(
          `paymentDetails`,
          JSON.stringify(updatedPaymentDetails)
        );
      }
    }
  }, [salesAmountToPass, netPayableAmount, isSaveNetPayableAmount]);

  // Reset all payment fields to 0 when net payable amount becomes negative
  // BUT only if it's not a credit situation (when user has manually set payment details)
  useEffect(() => {
    const currentNetPayable = isSaveNetPayableAmount
      ? Math.round(savedNetPayableAmount)
      : Math.round(manualNetPayAmountPayment);

    if (currentNetPayable < 0) {
      // Check if user has manually entered any payment details
      const hasManualPayments =
        parseFloat(paymentDetails.cash_amount || 0) > 0 ||
        parseFloat(paymentDetails.card_amt || 0) > 0 ||
        parseFloat(paymentDetails.chq_amt || 0) > 0 ||
        parseFloat(paymentDetails.online_amt || 0) !== 0;

      if (!hasManualPayments) {
        const resetPaymentDetails = {
          cash_amount: 0,
          card_amt: 0,
          chq_amt: 0,
          online_amt: 0,
        };

        setPaymentDetails(resetPaymentDetails);
        localStorage.setItem(
          `paymentDetails`,
          JSON.stringify(resetPaymentDetails)
        );
      }
    }
  }, [
    isSaveNetPayableAmount,
    savedNetPayableAmount,
    manualNetPayAmountPayment,
    paymentDetails,
  ]);

  //const [oldItemsSalesAmount, setOldItemsSalesAmount] = useState(0);
  // In your component state

  let rounded = Math.round(
    isSaveNetPayableAmount
      ? savedNetPayableAmount
      : Math.round(manualNetPayAmountPayment)
  );
  useEffect(() => {
    const storedPaymentDetails =
      JSON.parse(localStorage.getItem(`paymentDetails`)) || {};

    const cashAmount =
      location.state?.cash_amount ??
      storedPaymentDetails.cash_amount ??
      rounded;

    const cardAmt =
      location.state?.card_amt ?? storedPaymentDetails.card_amt ?? 0;

    const chqAmt = location.state?.chq_amt ?? storedPaymentDetails.chq_amt ?? 0;

    const onlineAmt =
      location.state?.online_amt ?? storedPaymentDetails.online_amt ?? 0;

    const newPaymentDetails = {
      cash_amount: cashAmount,
      card_amt: cardAmt,
      chq_amt: chqAmt,
      online_amt: onlineAmt,
    };

    setPaymentDetails(newPaymentDetails);
  }, [location.state, rounded]);
  useEffect(() => {
    // Only update if cash_amount is NOT provided from location.state
    if (rounded && location.state?.cash_amount === undefined) {
      setPaymentDetails((prev) => {
        const updatedDetails = {
          ...prev,
          online_amt: Math.round(rounded), // Ensure it's rounded to avoid decimal precision issues
        };
        localStorage.setItem(`paymentDetails`, JSON.stringify(updatedDetails));
        return updatedDetails;
      });
    }
  }, [rounded, location.state]);
  const handleSaveNetPayableAmount = () => {
    // Handle empty string or minus sign case
    if (
      editedManualNetPayAmountPayment === "" ||
      editedManualNetPayAmountPayment === "-"
    ) {
      alert("Please enter a valid net payable amount.");
      return;
    }

    const newNetPayableAmount = parseFloat(editedManualNetPayAmountPayment);
//
    // Calculate total deductions
    const totalAdvanceAmount = [...advanceEntries, ...newAdvanceEntries].reduce(
      (sum, entry) => sum + Number(entry.amount || 0),
      0
    );
    const totalDeductions =
      oldItemsAmount + schemeAmount + salesAmountToPass + totalAdvanceAmount;

    // Calculate the current net payable amount
    const currentNetPayable = netAmount - totalDeductions;

    // Calculate the difference between current and new net payable
    const netPayableDifference = currentNetPayable - newNetPayableAmount;

    // Calculate the maximum allowed net payable amount
    // This should be the net amount with zero regular discount (maximum possible)
    // Net Amount with zero regular discount = Total Amount - Festival Discount + Tax on (Total Amount - Festival Discount)
    const totalAmountWithZeroRegularDiscount =
      totalAmount - festivalDiscountAmt;
    const taxOnTotalAmount = (totalAmountWithZeroRegularDiscount * 3) / 100; // 3% GST
    const netAmountWithZeroRegularDiscount =
      totalAmountWithZeroRegularDiscount + taxOnTotalAmount;
    const maxAllowedNetPayable = Math.round(
      netAmountWithZeroRegularDiscount - totalDeductions
    );

    console.log("Maximum allowed calculation:", {
      totalAmount,
      festivalDiscountAmt,
      totalAmountWithZeroRegularDiscount,
      taxOnTotalAmount,
      netAmountWithZeroRegularDiscount,
      totalDeductions,
      maxAllowedNetPayable,
    });

    // Allow increasing net payable amount as long as it doesn't exceed the maximum
    if (newNetPayableAmount > maxAllowedNetPayable) {
      alert(
        `Net payable amount cannot exceed ${maxAllowedNetPayable}. Please enter a valid amount.`
      );
      return;
    }

    console.log("=== PaymentDetails Debug - Net Payable Change ===");
    console.log("Current netAmount:", netAmount);
    console.log("Current totalDeductions:", totalDeductions);
    console.log("Current netPayable:", currentNetPayable);
    console.log("New netPayableAmount:", newNetPayableAmount);
    console.log("netPayableDifference:", netPayableDifference);
    console.log("totalAmount:", totalAmount);
    console.log("taxableAmount:", taxableAmount);
    console.log("festivalDiscountAmt:", festivalDiscountAmt);

    // Calculate the original taxable amount (before any discount) like estimates v2
    // This ensures discount is always calculated from the original amount
    const originalTaxableAmount = totalAmount; // This is the amount before any discount

    console.log(
      "Original taxable amount (before discount):",
      originalTaxableAmount
    );
    console.log("Current taxable amount (after discount):", taxableAmount);
    console.log("URD Amount (oldItemsAmount):", oldItemsAmount);
    console.log("Sales Return Amount (salesAmountToPass):", salesAmountToPass);
    console.log("Total Deductions:", totalDeductions);

    // Use iterative approach like estimates v2 to find the exact discount percentage
    // that will result in the desired net payable amount
    let bestDiscountPercentage = 0;
    let bestDifference = Infinity;

    // Determine the range to search based on whether we're increasing or decreasing
    const isIncreasing = netPayableDifference < 0;

    // For increases: search from current discount down to 0 (reducing discount)
    // For decreases: search from current discount up to 100% (increasing discount)
    const currentDiscountPercentage = discount || 0;
    const startPercentage = isIncreasing
      ? Math.max(0, currentDiscountPercentage - 10)
      : Math.max(0, currentDiscountPercentage - 1);
    const endPercentage = isIncreasing
      ? Math.min(100, currentDiscountPercentage + 1)
      : Math.min(100, currentDiscountPercentage + 10);
    const stepSize = 0.0001;

    console.log("Searching for discount percentage:", {
      isIncreasing,
      currentDiscountPercentage,
      startPercentage,
      endPercentage,
      stepSize,
      targetNetPayable: newNetPayableAmount,
      netPayableDifference,
      originalTaxableAmount,
      festivalDiscountAmt,
    });

    // Try different discount percentages to find the one that gets us closest to the target
    // IMPORTANT: Calculate discount from ORIGINAL taxable amount, not current taxable amount
    // Festival discount is already applied at product level, so we work with the amount after festival discount
    for (
      let testPercentage = startPercentage;
      testPercentage <= endPercentage;
      testPercentage += stepSize
    ) {
      // Calculate regular discount from original amount (before festival discount)
      const testDiscountAmount = (originalTaxableAmount * testPercentage) / 100;

      // Calculate taxable amount: Original - Regular Discount - Festival Discount
      const testTaxableAmount =
        originalTaxableAmount - testDiscountAmount - festivalDiscountAmt;
      const testTaxAmount = (testTaxableAmount * 3) / 100; // 3% GST
      const testNetAmount = testTaxableAmount + testTaxAmount;
      const testNetAmountRounded = Math.round(testNetAmount * 100) / 100; // Round to 2 decimal places

      // Calculate net payable: Net Amount - Total Deductions (including URD and sales return)
      const testNetPayable = Math.round(testNetAmountRounded - totalDeductions);

      const difference = Math.abs(testNetPayable - newNetPayableAmount);

      console.log(
        `Test ${testPercentage.toFixed(
          4
        )}%: regularDiscount=${testDiscountAmount.toFixed(
          2
        )}, festivalDiscount=${festivalDiscountAmt.toFixed(
          2
        )}, taxable=${testTaxableAmount.toFixed(
          2
        )}, tax=${testTaxAmount.toFixed(2)}, net=${testNetAmountRounded.toFixed(
          2
        )}, netPayable=${testNetPayable}, target=${newNetPayableAmount}, diff=${difference.toFixed(
          2
        )}`
      );

      if (difference < bestDifference) {
        bestDifference = difference;
        bestDiscountPercentage = testPercentage;
      }

      // If we found an exact match, break
      if (difference < 0.01) {
        break;
      }
    }

    const roundedDiscountPercentage = parseFloat(
      bestDiscountPercentage.toFixed(10)
    );

    console.log("Best discount percentage found:", bestDiscountPercentage);
    console.log("Best difference:", bestDifference);
    console.log("Rounded discount percentage:", roundedDiscountPercentage);

    // Update the discount using the parent's discount change handler
    if (handleDiscountChange) {
      console.log(
        "Calling handleDiscountChange with:",
        roundedDiscountPercentage
      );
      handleDiscountChange({ target: { value: roundedDiscountPercentage } });
    }

    // Don't call handleManualNetPayableChange as it conflicts with our discount calculation
    // The discount change above will handle updating the net amount correctly

    // Update local state
    setEditedManualNetPayAmountPayment(newNetPayableAmount);
    setManualNetPayAmountPayment(newNetPayableAmount);
    setIsEditedNetPayableAmount(true);
    setIsSaveNetPayableAmount(true);
    setSavedNetPayableAmount(newNetPayableAmount);
    setIsManualNetPayableSet(true); // Mark as manually set to prevent auto-updates

    console.log("=== PaymentDetails Debug - After State Update ===");
    console.log("New netPayableAmount set to:", newNetPayableAmount);
    console.log("Expected Net Amount should be:", newNetPayableAmount);

    // Update payment details based on Net Payable Amount
    const updatedPaymentDetails = {
      cash_amount: 0,
      card_amt: 0,
      chq_amt: 0,
      online_amt: Math.round(newNetPayableAmount),
    };

    // Update payment details directly
    setPaymentDetails(updatedPaymentDetails);
    localStorage.setItem(
      `paymentDetails`,
      JSON.stringify(updatedPaymentDetails)
    );
  };
  const handleEdit = () => {
    if (isEditedNetPayableAmount) {
      setIsEditedNetPayableAmount(false);
    } else {
      setIsEditedNetPayableAmount(true);
    }
  };
  // Example useEffect to handle logic after state update
  useEffect(() => {
    // Perform any additional logic needed after the state update
  }, [manualNetPayAmountPayment]);

  return (
    <div>
      <Col className="sales-form-section">
        <Row>
          <h7 className="mb-3">Summary</h7>
          <Table bordered hover responsive>
            <tr style={{ fontSize: "13px" }}>
              <td colSpan="16" className="text-right">
                Total Amount
              </td>
              <td colSpan="4">{totalAmount.toFixed(2)}</td>
            </tr>
            {/* <tr style={{ fontSize: "13px" }}>
              <td colSpan="12" className="text-right">
                Discount Amount
              </td>
              {/* <td colSpan="4">
                {" "}
                <span
                  style={{
                    whiteSpace: "nowrap",
                    backgroundColor: "transparent",
                  }}
                >
                  @
                  <input
                    type="number"
                    value={discount}
                    onChange={handleDiscountChange}
                    style={{
                      width: "80px",
                      padding: "5px",
                      height: "23px",
                      fontSize: "12px",
                    }}
                  />
                </span>
              </td>
              <td colSpan="4">
                <input
                  type="number"
                  value={discountAmountInput}
                  onChange={(e) => {
                    setDiscountAmountInput(e.target.value);
                    handleDiscountAmountChange(e);
                  }}
                  style={{
                    width: "80px",
                    padding: "5px",
                    height: "23px",
                    fontSize: "12px",
                  }}
                />
              </td> */}

            {/* <td colSpan="12" className="text-right">
                Discount Amount
              </td> */}
            {/* <td colSpan="4">@ {discount ? discount.toFixed(2) : ""} %</td>
              <td colSpan="4">{Math.max(discountAmt ?? 0, 0).toFixed(2)}</td> */}
            {/* </tr>  */}
            <tr style={{ fontSize: "13px" }}>
              <td colSpan="12" className="text-right">
                Discount Amount
              </td>
              <td colSpan="4">@ {discount ? discount.toFixed(2) : ""} %</td>
              <td colSpan="4">{Math.max(discountAmt, 0).toFixed(2)}</td>
            </tr>
            <tr style={{ fontSize: "13px" }}>
              <td colSpan="12" className="text-right">
                Festival Offer
              </td>
              <td colSpan="4"> &ensp;&ensp;</td>

              <td colSpan="4">
                {festivalDiscountAmt.toFixed(2)}
                <Button
                  onClick={handleFestivalShowModal}
                  style={{
                    display: "none",
                    backgroundColor: "#a36e29",
                    borderColor: "#a36e29",
                    fontSize: "12px",
                    padding: "2px 8px",
                    marginLeft: "10px",
                  }}
                  size="sm"
                >
                  Apply Offer
                </Button>
              </td>
            </tr>

            <tr style={{ fontSize: "13px" }}>
              <td colSpan="16" className="text-right">
                Taxable Amount
              </td>
              <td colSpan="4">{taxableAmount.toFixed(2)}</td>
            </tr>
            <tr style={{ fontSize: "13px" }}>
              <td colSpan="16" className="text-right">
                Tax Amount
              </td>
              <td colSpan="4">{taxAmount.toFixed(2)}</td>
            </tr>
            <tr style={{ fontSize: "13px" }}>
              <td colSpan="16" className="text-right">
                Net Amount
              </td>
              <td colSpan="4">{Number(netAmount || 0).toFixed(2)}</td>
            </tr>
            <tr style={{ fontSize: "13px" }}>
              <td colSpan="16" className="text-right">
                Old Items Amount
              </td>
              <td colSpan="4">{oldItemsAmount.toFixed(2)}</td>
            </tr>
            <tr style={{ fontSize: "13px" }}>
              <td colSpan="16" className="text-right">
                Scheme Amount
              </td>
              <td colSpan="4">{schemeAmount.toFixed(2)}</td>
            </tr>
            <tr style={{ fontSize: "13px" }}>
              <td colSpan="16" className="text-right">
                Sale Return Amount
              </td>
              {/* <td colSpan="4">{salesNetAmount.toFixed(2)}</td> */}
              <td colSpan="4">{salesAmountToPass.toFixed(2)}</td>
            </tr>
            {/* <tr style={{ fontSize: "13px" }}>
              <td colSpan="16" className="text-right">
                Advance Amount
              </td>
              <td colSpan="4">
                <input
                  value={advanceAmount}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "") {
                      setAdvanceAmount("");
                      setAdvanceAmount("");
                    } else {
                      const numberValue = Number(value);
                      if (numberValue <= maxAdvanceAmount) {
                        setAdvanceAmount(numberValue);
                      } else {
                        alert(
                          `Advance Amount should not exceed ₹${maxAdvanceAmount.toFixed(
                            2
                          )}`
                        );
                        setAdvanceAmount("");
                      }
                    }
                  }}
                  style={{ width: "100px", padding: "5px", fontSize: "13px" }}
                  min="0"
                />
              </td>
            </tr> */}

            <tr style={{ fontSize: "13px" }}>
              {/* <td colSpan="16">
                Advance Amount
              </td> */}
              <td colSpan="20">
                <div>Advance Amount</div>

                <Table bordered size="sm" style={{ marginBottom: 0 }}>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Amount</th>
                      <th>Payment Method</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Preloaded entries */}
                    {advanceEntries?.map((entry, idx) => (
                      <tr key={`preloaded-${idx}`}>
                        <td>{entry.date}</td>
                        <td>₹{Number(entry.amount).toFixed(2)}</td>
                        <td>
                          {entry.paymentMethod
                            ? paymentMethods.find(
                                (m) => m.value === entry.paymentMethod
                              )?.label || entry.paymentMethod
                            : "-"}
                        </td>
                        <td>
                          {isPaymentEditable(entry.date) ? (
                            <Button
                              size="sm"
                              variant="danger"
                              onClick={() => handleRemoveAdvance(idx)}
                              style={{
                                padding: "2px 8px",
                                fontSize: "12px",
                                backgroundColor: "#A36E29",
                                borderColor: "#A36E29",
                              }}
                            >
                              −
                            </Button>
                          ) : (
                            <span style={{ color: "#666", fontSize: "12px" }}>
                              Locked
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                    {/* New entries */}
                    {newAdvanceEntries?.map((entry, idx) => (
                      <tr key={`new-${idx}`}>
                        <td>{entry.date}</td>
                        <td>₹{Number(entry.amount).toFixed(2)}</td>
                        <td>
                          {paymentMethods.find(
                            (m) => m.value === entry.paymentMethod
                          )?.label || entry.paymentMethod}
                        </td>
                        <td>
                          {isPaymentEditable(entry.date) ? (
                            <Button
                              size="sm"
                              variant="danger"
                              onClick={() =>
                                handleRemoveAdvance(idx + advanceEntries.length)
                              }
                              style={{
                                padding: "2px 8px",
                                fontSize: "12px",
                                backgroundColor: "#A36E29",
                                borderColor: "#A36E29",
                              }}
                            >
                              −
                            </Button>
                          ) : (
                            <span style={{ color: "#666", fontSize: "12px" }}>
                              Locked
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                    {/* Add new entry row */}
                    <tr>
                      <td>
                        <input
                          type="date"
                          value={
                            newAdvance.date ||
                            new Date().toISOString().split("T")[0]
                          }
                          style={{ width: "120px", fontSize: "12px" }}
                          placeholder="Date"
                          readOnly
                          disabled
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          value={newAdvance.amount}
                          onChange={(e) =>
                            setNewAdvance({
                              ...newAdvance,
                              amount: e.target.value,
                            })
                          }
                          style={{ width: "80px", fontSize: "12px" }}
                          min="0"
                          placeholder="Amount"
                        />
                      </td>
                      <td>
                        <select
                          value={newAdvance.paymentMethod}
                          onChange={(e) =>
                            setNewAdvance({
                              ...newAdvance,
                              paymentMethod: e.target.value,
                            })
                          }
                          style={{
                            width: "120px",
                            fontSize: "12px",
                            padding: "2px",
                          }}
                        >
                          <option value="">Select Method</option>
                          {paymentMethods.map((method) => (
                            <option key={method.value} value={method.value}>
                              {method.label}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td style={{ display: "flex", gap: "5px" }}>
                        <Button
                          size="sm"
                          onClick={handleAddAdvance}
                          style={{
                            padding: "2px 8px",
                            fontSize: "12px",
                            backgroundColor: "#A36E29",
                            borderColor: "#A36E29",
                          }}
                        >
                          +
                        </Button>
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <div>
                  <strong>
                    Total: ₹
                    {[...advanceEntries, ...newAdvanceEntries]
                      .reduce(
                        (sum, entry) => sum + Number(entry.amount || 0),
                        0
                      )
                      .toFixed(2)}
                  </strong>
                </div>
              </td>
            </tr>
            <tr style={{ fontSize: "13px" }}>
              <td colSpan="16" className="text-right">
                Net Payable Amount
              </td>
              {isEditedNetPayableAmount ? (
                <td colSpan="4">
                  {isSaveNetPayableAmount
                    ? Math.round(savedNetPayableAmount).toFixed(2)
                    : Math.round(editedManualNetPayAmountPayment).toFixed(2)}
                  {!isAssigned && (
                    <FontAwesomeIcon
                      icon={faPencil}
                      onClick={() => handleEdit()}
                      style={{
                        cursor: "pointer",
                        color: "black",
                        backgroundColor: "transparent",
                        marginLeft: "8px",
                      }}
                    />
                  )}
                </td>
              ) : (
                <td colSpan="4">
                  {!isAssigned ? (<input
                    ref={netPayableInputRef}
                    type="number"
                    style={{
                      width: "100px",
                      padding: "5px",
                      fontSize: "13px",
                    }}
                    value={
                      isSaveNetPayableAmount
                        ? savedNetPayableAmount === "" ||
                          savedNetPayableAmount === "-"
                          ? savedNetPayableAmount
                          : Math.round(savedNetPayableAmount)
                        : editedManualNetPayAmountPayment === "" ||
                          editedManualNetPayAmountPayment === "-"
                        ? editedManualNetPayAmountPayment
                        : Math.round(editedManualNetPayAmountPayment)
                    }
                    onChange={(e) => {
                      const inputValue = e.target.value;

                      // Allow empty input for backspace/clearing
                      if (inputValue === "" || inputValue === null) {
                        if (isSaveNetPayableAmount) {
                          setSavedNetPayableAmount("");
                          setEditedManualNetPayAmountPayment("");
                        } else {
                          setEditedManualNetPayAmountPayment("");
                        }
                        return;
                      }

                      // Allow minus sign for negative numbers
                      if (inputValue === "-") {
                        if (isSaveNetPayableAmount) {
                          setSavedNetPayableAmount("-");
                          setEditedManualNetPayAmountPayment("-");
                        } else {
                          setEditedManualNetPayAmountPayment("-");
                        }
                        return;
                      }

                      // For any other input, try to parse as number
                      const newValue = parseFloat(inputValue);

                      // Check if it's a valid number (including negative numbers)
                      if (isNaN(newValue)) {
                        return; // Don't update if it's not a valid number
                      }

                      // Round the value
                      const roundedValue = Math.round(newValue);

                      if (isSaveNetPayableAmount) {
                        setSavedNetPayableAmount(roundedValue);
                        setEditedManualNetPayAmountPayment(roundedValue);
                      } else {
                        setEditedManualNetPayAmountPayment(roundedValue);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSaveNetPayableAmount();
                      }
                    }}
                  />):isSaveNetPayableAmount
                    ? savedNetPayableAmount === "" ||
                      savedNetPayableAmount === "-"
                      ? savedNetPayableAmount
                      : Math.round(savedNetPayableAmount)
                    : editedManualNetPayAmountPayment === "" ||
                      editedManualNetPayAmountPayment === "-"
                    ? editedManualNetPayAmountPayment
                    : Math.round(editedManualNetPayAmountPayment)}
                  {!isAssigned && (
                  <button
                    onClick={() => handleSaveNetPayableAmount()}
                    style={{
                      backgroundColor: "#a36e29",
                      border: "1px solid #a36e29",
                      color: "white",
                      fontSize: "12px",
                      padding: "2px 8px",
                      marginLeft: "5px",
                      cursor: "pointer",
                      borderRadius: "3px",
                    }}
                  >
                    Save
                  </button>
                  )}
                </td>
              )}
            </tr>
          </Table>
        </Row>
      </Col>

      {/* <Col className="">
        <Row className="p-3">
          {/* <Col xs={12} md={4}>
            <InputField
              label="Online Amt"
              name="online_amt"
              value={String(
                paymentDetails.online_amt !== 0 && paymentDetails.online_amt !== undefined
                  ? Number(paymentDetails.online_amt).toFixed(2)
                  : netPayable !== undefined
                    ? Number(netPayable).toFixed(2)
                    : "0.00"
              )}
              onChange={(e) =>
                setPaymentDetails({
                  ...paymentDetails,
                  online_amt: Number(e.target.value),
                })
              }
            />

          </Col>

          <Col xs={12} md={4}>
            <InputField
              label="Card Amt"
              name="card_amt"
              value={paymentDetails.card_amt}
              onChange={(e) =>
                setPaymentDetails({
                  ...paymentDetails,
                  card_amt: e.target.value,
                })
              }
            />
          </Col>
          <Col xs={12} md={4}>
            <InputField
              label="Cheque Amt"
              name="chq_amt"
              value={paymentDetails.chq_amt}
              onChange={(e) =>
                setPaymentDetails({
                  ...paymentDetails,
                  chq_amt: e.target.value,
                })
              }
            />
          </Col>
          <Col xs={12} md={3}>
            <InputField
              label="Cash Amt"
              name="cash_amount"
              value={paymentDetails.cash_amount}
              onChange={(e) =>
                setPaymentDetails({
                  ...paymentDetails,
                  cash_amount: e.target.value,
                })
              }
            />
          </Col> */}
      {/* <Col xs={12} md={3}>
            <Button
              onClick={() => handleSave("orders")}
              style={{
                backgroundColor: "#a36e29",
                borderColor: "#a36e29",
                fontSize: "14px",
                marginTop: "3px",
                padding: "4px 8px",
              }}
            >
              Save
            </Button>
          </Col>
          <Col xs={12} md={2}>
            <Button
              type="button"
              variant="secondary"
              onClick={handleBack}
              style={{
                backgroundColor: "gray",
                marginLeft: "-55px",
                fontSize: "14px",
                marginTop: "3px",
                padding: "4px 8px",
              }}
            >
              Cancel
            </Button>
          </Col>
          <Col xs={12} md={4}>
            <Button
              type="button"
              variant="secondary"
              onClick={handleSave}
              style={{
                backgroundColor: "#a36e29",
                borderColor: "#a36e29",
                fontSize: "14px",
                marginTop: "3px",
                padding: "4px 8px",
              }}
            >
              Generate Sales
            </Button>
          </Col>
        </Row>
      </Col> */}
      <Col xs={8}>
        <div
          style={{
            display: "flex",
            gap: "16px",
            padding: "16px 12px",
            flexWrap: "wrap",
            alignItems: "flex-start",
          }}
        >
          {(
            <>
              {isTodayDate && showGenerateSale ? (
                <button
                  type="button"
                  onClick={async (e) => {
                    if (allReservedNeedsSave) {
                      setSaveLoader(true);
                      const saved = await handleSave(e, "orders");
                      setSaveLoader(false);
                      if (saved && formData.account_name && formData.mobile) {
                        handleGenerateSales(e);
                      }
                    } else {
                      handleGenerateSales(e);
                    }
                  }}
                  style={{
                    ...buttonStyle,
                    opacity: isGenerateDisabled ? 0.6 : 1,
                    cursor: isGenerateDisabled ? "not-allowed" : "pointer",
                  }}
                  disabled={isGenerateDisabled || saveLoading}
                >
                  {saveLoader ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Generating
                    </>
                  ) : (
                    "Generate Sales"
                  )}
                </button>
              ) : isTodayDate && !showGenerateSale && !isOrder? (
                <button
                  onClick={async (e) => {
                    setSaveLoader(true);
                    const saved = await handleSave(e, "orders");
                    setSaveLoader(false);
                    if (saved && formData.account_name && formData.mobile) {
                      navigate(`/orderstable/${formData.order_number}`);
                    }
                  }}
                  style={buttonStyle}
                  disabled={saveLoading}
                >
                  {saveLoader ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Assigning
                    </>
                  ) : (
                    "Assign to Vendor"
                  )}
                </button>
              ) : (
                <button
                  onClick={async (e) => {
                    setSaveLoader(true);
                    const saved = await handleSave(e, "orders");
                    setSaveLoader(false);
                    if (saved && formData.account_name && formData.mobile) {
                      alert("Order updated successfully!");
                    }
                  }}
                  disabled={saveLoading}
                  style={buttonStyle}
                >
                  {saveLoader ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Updating
                    </>
                  ) : (
                    "Update"
                  )}
                </button>
              )}
            </>
          )}

          <button
            onClick={handleBack}
            style={{
              backgroundColor: "gray",
              border: "1px solid gray",
              color: "white",
              fontSize: "14px",
              padding: "4px 8px",
              marginTop: "3px",
              cursor: "pointer",
              borderRadius: "4px",
            }}
          >
            Close
          </button>
        </div>
      </Col>
    </div>
  );
};

export default PaymentDetails;
